import React from "react";
import { browseCategories } from "../../assets";
import { Wrapper } from "../styles";
import { CustomDivider } from "../styles/Main.styled";

const BrowseCategory = () => {
  return (
    <Wrapper isCenter isSection>
      <Wrapper>
        <h3>Most popular categories</h3>
        <h1>Browse Category</h1>
        <CustomDivider isCenter />
      </Wrapper>
    <Wrapper type="container">
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          minHeight: "500px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {browseCategories.map(({ id, image, name }) => (
          <div
            key={`category ${name} - ${id}`}
            style={{
              width: "377px",
              height: "244px",
              position: "relative",
              display: "block",
              margin: "30px 20px",
            }}
          >
            <img
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              src={image}
              alt={`category ${name}`}
            />
            <div
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                background: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <h3 style={{ color: "white" }}>
                {name}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </Wrapper>
      
    </Wrapper>
  );
};

export default BrowseCategory;
